import React from 'react';
import { TimeSlot } from '../../utils/getBlueprintSlots';

export type BlueprintSchedulingState = 'slot-selection' | 'booking-success';
export type BlueprintSchedulingMode = 'create' | 'reschedule';

export type BlueprintSchedulingContext = {
  showSchedulingDialog: boolean;
  setShowSchedulingDialog: (isFeedbackFlow?: boolean) => void;
  setHideSchedulingDialog: () => void;
  state: BlueprintSchedulingState;
  setState: (state: BlueprintSchedulingState) => void;
  selectedSlot: TimeSlot | null;
  setSelectedSlot: (slot: TimeSlot | null) => void;
  /** Mode: 'create' for new bookings, 'reschedule' for modifying existing */
  mode: BlueprintSchedulingMode;
  setMode: (mode: BlueprintSchedulingMode) => void;
  /** Booking ID for reschedule mode */
  bookingId: string | null;
  setBookingId: (bookingId: string | null) => void;
  /** Helper to open dialog in reschedule mode */
  openRescheduleDialog: (bookingId: string) => void;
  /** Selected timezone for booking */
  selectedTimezone: string;
  setSelectedTimezone: (timezone: string) => void;
  /** Whether this is a feedback flow booking */
  isFeedbackFlow: boolean;
  setIsFeedbackFlow: (isFeedbackFlow: boolean) => void;
};

const blueprintSchedulingContext = React.createContext<BlueprintSchedulingContext | undefined>(
  undefined
);

export const BlueprintSchedulingContextProvider = blueprintSchedulingContext.Provider;

export const useBlueprintSchedulingContext = () => {
  const context = React.useContext(blueprintSchedulingContext);
  if (!context) {
    throw new Error(
      'useBlueprintSchedulingContext must be used within a BlueprintSchedulingContextProvider'
    );
  }
  return context;
};
